var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderNavigation'),_c('transition',{attrs:{"name":"opaque"}},[_c('router-view')],1),_c('FooterNavigation'),_c('InternetConnectionStatusToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }